<template>
  <Popup v-bind="$attrs" v-on="$listeners">

      <div class="form-box">
        <el-form ref="form" label-width="80px">
          <el-form-item label="姓名">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="活动区域">
            <el-select v-model="form.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          
          
          <div class="dialog-footer">
            <!-- <Btn @click.native="close" title="取消" icon="none"></Btn> -->
            <Btn title="提交" icon="none" color="red"></Btn>
          </div>

        </el-form>
      </div>

  </Popup>
</template>

<script>
import Btn from '@/components/Button/Btn.vue';
import Popup  from '@/components/popup.vue'

export default {
  name: 'commit',
  components:{Popup,Btn},
  data(){
    return {
      form:{
        name: '',
        mobile:'',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    }
  },
  // inheritAttrs:false,
  methods:{
    close(){
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.form-box{padding:1vw 2vw 1vw 1vw;}
.dialog-footer{text-align:center;}
.dialog-footer button{margin:0 0.5vw;}


@media (max-width:991px){


}
</style>